import React, { useState } from 'react';
import { assignmentService, userService } from '../services/api';

export default function ReviewerAccountControls({ reviewer, session, onChange, onError }) {
  const [account, setAccount] = useState(null);
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState('');
  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState('');
  const canLink = session.can('reviewers.update') && session.can('users.update') && session.can('users.view');
  const open = async () => {
    setBusy(true); setNotice('');
    try {
      const [link, accounts] = await Promise.all([assignmentService.account(reviewer.id), userService.getAll()]);
      setAccount(link.data); setSelected(String(link.data.userId || '')); setUsers(accounts.data);
    } catch (error) { onError(error); }
    finally { setBusy(false); }
  };
  const link = async event => {
    event.preventDefault(); setBusy(true); setNotice('');
    try {
      const { data } = await assignmentService.linkAccount(reviewer.id, { userId: selected ? Number(selected) : null, expectedVersion: account.linkVersion });
      onChange({ ...reviewer, hasAccount: data.userId !== null, linkVersion: data.linkVersion });
      setAccount(null); setNotice('اتصال حساب ذخیره شد.');
    } catch (error) { onError(error); }
    finally { setBusy(false); }
  };
  const toggle = async () => {
    setBusy(true); setNotice('');
    try {
      const { data } = await assignmentService.availability(reviewer.id, { isActive: !reviewer.isActive, expectedVersion: reviewer.linkVersion });
      onChange(data); setAccount(null); setNotice('وضعیت داور ذخیره شد.');
    } catch (error) { onError(error); }
    finally { setBusy(false); }
  };
  return <div className="border-t mt-4 pt-3">
    <p>وضعیت: {reviewer.isActive ? 'فعال' : 'غیرفعال'} · {reviewer.hasAccount ? 'حساب متصل است' : 'بدون حساب متصل'}</p>
    <div className="flex flex-wrap gap-4 mt-2">
      {session.can('reviewers.update') && <button disabled={busy} className="text-blue-700" onClick={toggle}>{reviewer.isActive ? 'غیرفعال کردن' : 'فعال کردن'}</button>}
      {canLink && <button disabled={busy} className="text-blue-700" onClick={open}>اتصال حساب کاربری</button>}
    </div>
    {notice && <p role="status" className="text-green-800 mt-2">{notice}</p>}
    {account && <form onSubmit={link} className="mt-3 space-y-3">
      <p className="text-gray-600">فقط حساب موجود را انتخاب کنید. برای تغییر یا قطع اتصال، ابتدا تخصیص‌های فعال را لغو یا منتقل کنید.</p>
      <label className="block">حساب کاربری
        <select aria-label="حساب کاربری" disabled={busy} value={selected} onChange={event => setSelected(event.target.value)} className="block border rounded p-2 w-full mt-1">
          <option value="">بدون اتصال</option>
          {users.map(user => <option key={user.id} value={user.id}>{user.username} — {user.email}</option>)}
        </select>
      </label>
      <button disabled={busy} className="bg-blue-700 text-white rounded px-4 py-2">ذخیره اتصال</button>
      <button type="button" disabled={busy} onClick={() => setAccount(null)} className="mr-3">بستن</button>
    </form>}
  </div>;
}
